<template>
  <b-row>
    <b-col>
      <div class="text-center m-4">
        <font-awesome-icon
          icon="exclamation-triangle"
          size="6x"
          class="text-lightblue mb-2"
        />
        <h5>You have no active deals yet.</h5>
        <p>
          Once your deals are active, we will be displaying information here.
        </p>
      </div>
    </b-col>
  </b-row>
</template>


<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';


library.add(faExclamationTriangle);


export default {

};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/stats/EmptyLoans.vue